/* file description */

import { TransformNalmalType2TableColumn } from './type';
import { VALUE_TYPES, COLUMN_FROM } from './consts';
import { Checkbox, message, Switch } from 'antd';
import _ from 'lodash';
import React from 'react';
import { Switch as MobileSwitch } from 'antd-mobile';

enum BoolShowType {
  CHECOBOX = 'checkbox',
  SWITCH = 'switch',
}

function SwitchX(props: any) {
  const {
    checked,
    value,
    onChange,
    trueValue,
    checkedChildren,
    falseValue,
    unCheckedChildren,
    isMobile,
    ...otherProps
  } = props;

  let isChecked = value;
  if (trueValue !== undefined && falseValue !== undefined) {
    isChecked = value === trueValue;
  }
  const _onChange = (_checked: boolean, e?: any) => {
    if (_checked === trueValue) {
      onChange(trueValue, e);
    } else if (_checked === falseValue) {
      onChange(falseValue, e);
    } else {
      onChange(_checked, e);
    }
  };

  if (isMobile) {
    return (
      <MobileSwitch
        checked={isChecked}
        onChange={_onChange}
        checkedText={checkedChildren}
        uncheckedText={unCheckedChildren}
        {...otherProps}
      />
    );
  }

  return (
    <Switch
      checked={isChecked}
      onChange={_onChange}
      checkedChildren={checkedChildren}
      unCheckedChildren={unCheckedChildren}
      {...otherProps}
    />
  );
}

export const transformAssetBoolColumn: TransformNalmalType2TableColumn = ({
  targetColumn,
  field,
  isMobile,
}) => {
  // console.groupCollapsed(`${field?.label}#${field?.name} transformAssetBoolColumn`);
  // console.log('入参field', _.cloneDeep(field));
  // console.log('入参targetColumn', _.cloneDeep(targetColumn));

  const bizConfig = field?.bizConfig || {};
  const {
    showType = BoolShowType.SWITCH,
    trueLabel = '',
    trueValue = true,
    falseLabel = '',
    falseValue = false,
  } = bizConfig;

  // 如果是switch 类型
  if (showType === BoolShowType.SWITCH) {
    targetColumn.valueType = VALUE_TYPES.SWITCH;
    targetColumn.fieldProps = (form, config) => {
      const fieldProps: any = {
        trueValue,
        checkedChildren: trueLabel,
        falseValue,
        unCheckedChildren: falseLabel,

        // 移动端专属属性
        checkedText: trueLabel,
        uncheckedText: falseLabel,
      };
      return fieldProps;
    };

    targetColumn.renderFormItem = (schema, config, form) => {
      return <SwitchX isMobile={isMobile} />;
    };
  }

  // 如果是默认即checkbox类型
  // if (showType === BoolShowType.CHECOBOX) {
  //   targetColumn.valueType = VALUE_TYPES.CHECKBOX;
  //   targetColumn.renderFormItem = (schema, config, form) => {
  //     return <Checkbox />
  //   }
  //   targetColumn.valueEnum = {
  //     [trueValue]: {
  //       text: trueLabel,
  //     },
  //   }
  // }

  // 展示态渲染
  targetColumn.render = (dom, entity, index, action, schema) => {
    const targerValue = entity?.value;
    if (targerValue === trueValue) {
      return trueLabel || (targerValue).toString();
    }
    if (targerValue === falseValue) {
      return falseLabel || (targerValue).toString();
    }
    return targerValue || '';
  };

  // console.log('处理后targetColumn', _.cloneDeep(targetColumn));
  // console.groupEnd();

  return targetColumn;
};
